"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireWildcard(require("react"));
var _Swipe = _interopRequireDefault(require("./Swipe"));
var _Offset = _interopRequireDefault(require("./Offset"));
var _helpers = require("./helpers");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function getOffset(index, count) {
  return (0, _helpers.modulusPositive)(index + 1, count) - 1;
}
function getItems(items, mainOffset) {
  return items.map(function (item, i) {
    return {
      item: item,
      index: i
    };
  }).filter(function (_ref) {
    var index = _ref.index;
    var offset = getOffset(index - mainOffset, items.length);
    return offset > -2 && offset < 2;
  });
}
var Carousel = exports.default = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2.default)(Carousel, _Component);
  function Carousel() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.container = null;
    _this.width = 1;
    _this.swipe = new _Swipe.default(_this.update.bind((0, _assertThisInitialized2.default)(_this)), _this.onRelease.bind((0, _assertThisInitialized2.default)(_this)));
    _this.offset = new _Offset.default(_this.props.selectedIndex);
    _this.pendingFrame = null;
    _this.startTime = null;
    _this.boundRefs = [];
    _this.state = {
      items: getItems(_this.props.items, Math.round(_this.offset.getOffset())),
      offset: _this.props.selectedIndex
    };
    _this.setWidth = function () {
      _this.width = _this.container.offsetWidth;
    };
    _this.bindRef = function (i) {
      return function (ref) {
        _this.boundRefs[i] = ref;
      };
    };
    return _this;
  }
  var _proto = Carousel.prototype;
  _proto.update = function update() {
    var _this2 = this;
    if (!this.pendingFrame) {
      this.pendingFrame = requestAnimationFrame(function (time) {
        _this2.pendingFrame = null;
        _this2.startTime = _this2.startTime || time;
        _this2.run(time);
      });
    }
  };
  _proto.run = function run(time) {
    if (this.swipe.touch !== null) {
      this.offset.setOffset(this.offset.getOffset() - this.swipe.getDeltaX() / this.width, this.props.items.length);
      this.swipe.reset();
    } else {
      var done = this.offset.update(time);
      if (!done) {
        this.update();
      }
    }

    // Update state.items if offset requires new items
    if (Math.abs(this.offset.getOffset() - this.state.offset) >= 1) {
      this.setState({
        items: getItems(this.props.items, Math.round(this.offset.getOffset())),
        offset: Math.round(this.offset.getOffset())
      });
    }
    this.updateTransforms();
  };
  _proto.updateTransforms = function updateTransforms() {
    var _this3 = this;
    this.state.items.forEach(function (item, i, arr) {
      var ref = _this3.boundRefs[i];
      if (ref) {
        var transform = arr.length === 1 ? 0 : getOffset(item.index - _this3.offset.getOffset(), _this3.props.items.length);
        ref.style.transform = "translateX(" + transform * 100 + "%)";
      }
    });
  };
  _proto.onRelease = function onRelease() {
    this.offset.setTarget(this.props.selectedIndex, this.props.items.length);
    this.props.onOffsetChange(this.offset.getOffset());
  };
  _proto.componentDidUpdate = function componentDidUpdate(_ref2) {
    var selectedIndex = _ref2.selectedIndex,
      transition = _ref2.transition;
    if (selectedIndex !== this.props.selectedIndex) {
      if (transition) {
        this.offset.setTarget(this.props.selectedIndex, this.props.items.length);
      } else {
        this.offset.setOffset(this.props.selectedIndex, this.props.items.length);
      }
      this.update();
    }
  };
  _proto.componentDidMount = function componentDidMount() {
    this.setWidth();
    window.addEventListener('resize', this.setWidth);
    this.updateTransforms();
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener('resize', this.setWidth);
    if (this.pendingFrame) {
      cancelAnimationFrame(this.pendingFrame);
    }
  };
  _proto.render = function render() {
    var _this4 = this;
    return /*#__PURE__*/_react.default.createElement("div", {
      ref: function ref(_ref4) {
        _this4.container = _ref4;
      },
      onTouchStart: this.swipe.onTouchStart,
      onTouchEnd: this.swipe.onTouchEnd,
      onTouchMove: this.swipe.onTouchMove
    }, this.props.children({
      bindRef: this.bindRef,
      items: this.state.items.map(function (_ref3) {
        var item = _ref3.item;
        return item;
      })
    }));
  };
  return Carousel;
}(_react.Component);
Carousel.defaultProps = {
  selectedIndex: 0,
  items: [],
  transition: true,
  onOffsetChange: function onOffsetChange() {
    return null;
  }
};